module.exports = __webpack_public_path__ + "751ebb698a82066a7d7a194778afdafb.png";